angular.module('ui-ng-university-branding')
  .directive('phxUniversityBranding', function (
    DelegateResponder,
    phxUniversityBrandingDelegateConstant) {
    return {
      scope: {
        additionalStyles: '=?',
        secondaryColor: '=?',
        primaryColor: '=?',
        textColor: '=?'
      },
      restrict: 'E',
      link: DelegateResponder(phxUniversityBrandingDelegateConstant, (scope, element, attrs) => {}),
      controller: function ($scope, $element) {

        const DEFAULTS = {
          secondaryColor: 'default',
          primaryColor: 'default',
          textColor: 'default',
          additionalStyles: ''
        };

        let brandConfig = _.merge(DEFAULTS, {});

        $scope.updateColors = (config) => {
          brandConfig = _.merge(DEFAULTS, config);
          updateStyles();
        };

        const parseStyles = (template) => {
          let compileTpl = _.template(template);

          return compileTpl({
            primary: $scope.primaryColor,
            secondary: $scope.secondaryColor,
            text: $scope.textColor
          });
        };

        const styleTemplate = `
          .university-primary-bkg {
            background: {{primary}};
            color: {{text}};
          }
          .university-primary-txt {
            color: {{primary}};
          }
          .university-primary-bdr {
            border-color: {{primary}};
          }
          .university-secondary-bkg {
            background: {{secondary}};
          }
          .university-secondary-txt {
            color: {{secondary}};
          }
          .university-secondary-bdr {
            border-color: {{secondary}};
          }
          .university-default-txt {
            color: {{text}}
          }
        `;

        const updateStyles = () => {
          _.assign($scope, brandConfig);
          $scope.compiledAdditionalStyles = parseStyles($scope.additionalStyles);
          $scope.universityStyles = parseStyles(styleTemplate) + $scope.compiledAdditionalStyles;
          $element.html(`<style type='text/css'> ${$scope.universityStyles}</style>`);
        };

        updateStyles();

      }
    }
  })
  .constant('phxUniversityBrandingDelegateConstant', {
    uniqueComponent: 'phx-university-branding',
    vocabulary: {
      read: function (scope, element, attrs, event, ) {
        this.read();
      },
      update: function (scope, element, attrs, event, config) {
        this.updateColors(config);
      }
    }
  })
  .service('phxUniversityBrandingDelegate', function (
    DelegateController,
    phxUniversityBrandingDelegateConstant) {
    DelegateController(this, phxUniversityBrandingDelegateConstant);
  });




// WEBPACK FOOTER //
// university_dynamic_branding.es.js